import React from 'react';
import { observer } from 'mobx-react';
import { ReferenceChangeCellTemplate } from 'themes/application/import/components';

@observer
class ReferenceChangeCell extends React.Component {
    render() {
        return (
            <ReferenceChangeCellTemplate {...this.props}/>
        );
    }
}

export default ReferenceChangeCell;